import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

import * as AdminActions from './admin.actions';

@Injectable()
export class AdminEffects {
  loadAdmins$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AdminActions.loadAdmins),
      concatMap(() =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        EMPTY.pipe(
          map(data => AdminActions.loadAdminsSuccess({ data })),
          catchError(error => of(AdminActions.loadAdminsFailure({ error })))
        )
      )
    );
  });

  constructor(readonly actions$: Actions) {}
}
